export default __webpack_public_path__ + "static/media/83D34298-B11A-42EF-9B5C-D4E812E0F31D_1_105_c.51a37145.jpeg";